<script lang="ts">
  import { getContext, type Snippet } from "svelte";
  import { melt, createDropdownMenu } from "@melt-ui/svelte";

  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  type MenuContext = typeof createDropdownMenu & {
    submenu: ReturnType<ReturnType<typeof createDropdownMenu>["builders"]["createSubmenu"]>;
  };

  const {
    submenu: {
      elements: { subMenu },
      states: { subOpen },
    },
  } = getContext<MenuContext>("menu");
</script>

{#if $subOpen}
  <div
    class="submenu flex w-auto max-w-[220px] min-w-[160px] translate-x-3 flex-col gap-1 rounded-[20px] p-4 text-sm text-mono-000 shadow-sm backdrop-blur-xs dark:text-mono-900"
    {...$subMenu} use:$subMenu.action
  >
    {@render children?.()}
  </div>
{/if}

<style>
  @reference "#tailwind.css";
  .submenu {
    background: var(--color-popover);
    box-shadow:
      0px 1px 2px 0px rgba(0, 0, 0, 0.04),
      0px 16px 24px -12px rgba(0, 0, 0, 0.08);
    max-width: 224px;
  }
</style>
